import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-17595 — every account a stage clean-up migration moved: from which stage
 * to which, and why, so the move can be reversed exactly (the migration runner
 * writes no `_audit` rows). Written only by migrations; append-only, so it is
 * not audited itself.
 */
@Index('IDX_client_lifecycle_stage_move_client', ['fkClientId'], {})
@Entity('client_lifecycle_stage_move', {}, { auditable: false })
export class ClientLifecycleStageMoveEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	/** Null when the account had no stage. */
	@Column('int', { name: 'fromStageId', unsigned: true, nullable: true })
	public fromStageId!: number | null;

	@Column('int', { name: 'toStageId', unsigned: true })
	public toStageId!: number;

	/** The migration and rule that moved it (e.g. "RelabelAccountStages: Proposal → Lead"). */
	@Column('varchar', { name: 'reason', length: 255 })
	public reason!: string;
}
